import {useParams} from 'react-router-dom';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {InstanceComplianceStandardsForm} from 'src/app/instance-compliance-standards/InstanceComplianceStandardsForm';
import {ComplianceStandardsBrowserShell} from 'src/app/compliance-standards/ComplianceStandardsBrowserShell';
import {toComplianceTreeNodeId} from 'src/app/compliance-standards/complianceStandardTreeState';
import {useGetInstanceComplianceStandardQuery} from 'src/redux/queries/complianceStandard';
import {InstanceComplianceStandardDocumentTitle} from 'src/app/instance-compliance-standards/instanceComplianceStandardsHelper';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const ViewInstanceComplianceStandardPage = () => {
  useSetDocumentTitle(InstanceComplianceStandardDocumentTitle);
  const {id} = useParams();
  const {data: instanceStandard} = useGetInstanceComplianceStandardQuery(
    Number(id),
    {skip: !id}
  );

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Compliance}>
      <ComplianceStandardsBrowserShell
        variant="regulatory"
        selectedId={
          instanceStandard
            ? toComplianceTreeNodeId(instanceStandard.standard)
            : undefined
        }>
        <InstanceComplianceStandardsForm id={Number(id)} mode="view" />
      </ComplianceStandardsBrowserShell>
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.InstanceComplianceStandardsView(':id'),
  element: <ViewInstanceComplianceStandardPage />,
  module: ModuleEnum.Compliance,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default ViewInstanceComplianceStandardPage;
